/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Pagination, PaginationItem, PaginationLink, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

const ServiceRequests = props => {

    // variables
    let timeout = 0;

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [serviceRequests, setServiceRequests] = useState([]);
    const [modal, setModal] = useState({ isVisible: false, selectedIndex: -1 });
    const [confirmationModal, setConfirmationModal] = useState({ isVisible: false, selectedIndex: -1 });
    const [pagination, setPagination] = useState({ limit: 10, page: 1, searchVal: "" });

    // contexts
    const { theme } = useContext(ThemeContext);

    // use Effects
    useEffect(() => {
        // if (!isLoading) {
        //     setIsLoading(true);
        AdminService.getServiceRequests(pagination.limit, pagination.page, pagination.searchVal).then(data => {
            try {
                // console.log('data', data);
                setServiceRequests(data.serviceRequests);
                if (data.pagination.totalPages <= data.pagination.page) {
                    data.pagination.page = data.pagination.totalPages;
                }
                setPagination(data.pagination);
                setIsLoading(false);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at Admin ServiceRequests useEffect', 'Error in try catch block', err.stack);
                setIsLoading(false);
            }
        });
        // }
    }, [pagination.page, pagination.limit, pagination.searchVal]);

    // handle functions
    const handleSearch = e => {
        try {
            let value = e.target.value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPagination({ ...pagination, searchVal: value });
            }, 500);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin ServiceRequests handleSerach', 'Error in try catch block', err.stack);
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            // if(e.target.id === "limit"){
            //     const value = e.target.value;
            //     setTimeout(() => {
            //         setPagination({...pagination, limit: value});
            //     }, 500);
            // }
            // else
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin ServiceRequests handlePagination', 'Error in try catch block', err.stack);
        }
    }

    const showDetails = () => { }

    const handleToggleChange = (index) => {
        try {
            setIsLoading2(true);
            let tempServiceRequests = [...serviceRequests];
            tempServiceRequests[index].isActive = !tempServiceRequests[index].isActive;
            setServiceRequests(tempServiceRequests);
            AdminService.updateServiceRequests({ id: tempServiceRequests[index]._id, isActive: tempServiceRequests[index].isActive })
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setConfirmationModal({ isVisible: false, selectedIndex: -1 });
                    setIsLoading2(false);
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading2(false);
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading2(false);
            GeneralService.logError('at Admin ServiceRequests handleToggleChange', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">Service Requests</h3>
                <div className="card mb-4">
                    <div className="card-header d-flex">
                        <label className="my-auto">Requests</label>
                    </div>
                    <div className="card-body py-0">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <td colSpan="7" className="border-0 px-0">
                                            <div className="d-flex">
                                                <div className="ml-auto">
                                                    Search<input type="text" id="searchInput" className="ml-2" style={{ marginRight: "-20px", paddingRight: "20px" }} onChange={handleSearch}></input>
                                                    <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("searchInput").value = ""; setPagination({ ...pagination, searchVal: "" }); }}><i className="fa fa-times"></i></span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Institution / Organisation Name</th>
                                        <th>Institution / Organisation Email</th>
                                        <th>Service Requested</th>
                                        <th>Requested On</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        serviceRequests.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.requester.name}</td>
                                                <td>{item.requester.email}</td>
                                                <td>{item.institution.name}</td>
                                                <td>{item.institution.email}</td>
                                                <td>{item.requestedService.name}</td>
                                                <td>{moment(item.createdAt).format('DD MMM YYYY')}</td>
                                                <td align="center"><a style={{ color: "#384E73" }} href="#" onClick={() => showDetails(index)}>Details</a></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="7" className="border-0 pb-0 px-0">
                                            <div className="d-flex">
                                                <ErrorBoundary errorAt="At Admin ServiceRequests Pagination">
                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                        <PaginationItem disabled={pagination.page == 1}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                previous
                                                                href="#" />
                                                        </PaginationItem>
                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                    {i + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        )}
                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                next
                                                                href="#" />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </ErrorBoundary>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )

}

export default ServiceRequests;